import { Box } from '@hopskipdrive/react-components';
import { colorPalette, colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Emphasis = styled.span`
  font-style: italic;
`;

export const Bold = styled.span`
  color: ${colorTokens.text.dark};
`;

export const DatesBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 12px;
  color: ${colorPalette.neutral50};
`;

export const TripsContainer = styled(Box)`
  padding: 1.5rem;
  margin-bottom: 1.25rem;
  border-radius: 20px;
  border: 1px solid ${colorPalette.neutralVariant90};

  & > *:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
